




import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      required: false,
    },
    prefix: {
      type: String,
      required: false,
    },
    suffix: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      localVal: this.value,
      ruleChecks: {
        numeric: (value: any) => !Number.isNaN(parseFloat(value)) || 'Valid number required',
      },
    };
  },

  methods: {
    valueChanged(newVal: string) {
      const v = parseFloat(newVal);
      if (!Number.isNaN(v)) {
        this.localVal = v;
        this.$emit('input', v);
      }
    },
  },

  computed: {
    displayVal(): string {
      return this.localVal.toString();
    },
  },
});
